export enum OperatingSystem {
  Mac,
  Win,
  Linux,
}
